/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-11",
    versionChannel: "nightly",
    buildDate: "2025-06-11T00:07:25.278Z",
    commitHash: "2b20cc9e7b71b6ff0cd36dfe5d5863b140c12ede",
};
